import React, {useState} from 'react'
import ClickOutside from 'react-click-outside'
import useQuery from 'apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'
import styles from './styles.css'
import UserAvatar from 'App/Pages/Inbox/UserMenu/UserAvatar'
import {sortAgents} from 'src/App/Pages/Inbox/helpers'

export default function SelectAgentMenu({value, onChange}) {
  const [open, setIsOpen] = useState(false)

  const {agents} = useQuery({
    query: gql`
      query {
        agents: supervisors {
          _id
          fullName
          activeForAutoAssignChat
        }
      }
    `,
    pollInterval: 10000
  })

  const activeAgents = (agents || []).sort(sortAgents)

  let userName, active
  if (value) {
    userName = value.fullName
    active = value.activeForAutoAssignChat
  }

  return (
    <ClickOutside onClickOutside={() => setIsOpen(false)}>
      <div className={styles.assignMenuContainer}>
        <div role="button" onClick={() => setIsOpen(op => !op)}>
          <UserAvatar userName={userName} active={active} />
        </div>

        {open ? (
          <div className={styles.options}>
            <h4 className={styles.header}>Asignar a un compañero</h4>
            <div
              className={styles.option}
              onClick={async () => {
                await onChange(null)
                setIsOpen(false)
              }}>
              <UserAvatar small />
              <span>Nadie</span>
            </div>
            {activeAgents.map(({_id, fullName, activeForAutoAssignChat}) => (
              <div
                className={styles.option}
                key={_id}
                onClick={async () => {
                  await onChange(_id)
                  setIsOpen(false)
                }}>
                <UserAvatar userName={fullName} active={activeForAutoAssignChat} small />
                <span>{fullName}</span>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </ClickOutside>
  )
}
